import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { rootRoute } from '../../../config';
import { motion } from "framer-motion";
import { play_simulation, place_order, save_userData } from '../services/api';
import { errorMsg } from '../../../helper/helpers';
import OrderTable from './OrderTable';
import Button from '../../common/Button'
import OrderHistory from './OrderHistory';
import SimProgress from './SimProgress';
import CalProfitLoss from './CalProfitLoss';
import RevenueGraph from './RevenueGraph';
import InventoryGraph from './InventoryGraph';
import { useOutletContext } from "react-router-dom";
import ImModuleStyle from '../styles/im.module.css';
import info from '../assets/info.png';
import ReactDOM from 'react-dom';
import GraphDataTable from './GraphDataTable';
import help from '../../../assets/help.png';

const Simulation = () => {
  const [quantity, setQuantity] = useState(50);
  const [shippingType, setShippingType] = useState("NORMAL_SHIPPING");
  const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, isPopupShown, setIsPopupShown, accordionPopup, setAccordionPopup, simObj, setSimObj, getMonth, toggleSimulation, setToggleSimulation, startOverSimulation, isLoader, setIsLoader, setAriaProperty, check_Location, setError, error, simType, calculatorPopup, setCalculatorPopup, kpisPopup, setKpisPopup, relaunchPopup, setRelaunchPopup, expandCalcPopup, setExpandCalcPopup,focusPopUp, isModalVisible, setIsModalVisible] = useOutletContext();
  const [isDecisionPopup, setIsDecisionPopup] = useState(false);
  const [isFromHelp, setIsFromHelp] = useState(false);
  let qd = 0, qs = 0, qh = 0, dd = 0, dw = 0, ropd = 0, ropl = 0;
  const [calculator, setCalculator] = useState({ qd: qd, qs: qs, qh: qh, dd: dd, dw: dw, ropd: ropd, ropl: ropl });
  const [accordion_Popup, setAccordion_Popup] = useState(false);
  const [isShowPlaceOrder, setIsShowPlaceOrder] = useState(false);
  const [isRequestLoading, setIsRequestLoading] = useState(false);
  const [isCalculatorOpen, setIsCalculatorOpen] = useState(false);
  //Calculator Popup Top
  const [calculatorQPopupTop, setCalculatorQPopupTop] = useState(0);
  const [calculatorQdPopupTop, setCalculatorQdPopupTop] = useState(0);
  const [calculatorQsPopupTop, setCalculatorQsPopupTop] = useState(0);
  const [calculatorQhPopupTop, setCalculatorQhPopupTop] = useState(0);
  const [calculatorQ1PopupTop, setCalculatorQ1PopupTop] = useState(0);
  const [calculatorDdPopupTop, setCalculatorDdPopupTop] = useState(0);
  const [calculatorDwPopupTop, setCalculatorDwPopupTop] = useState(0);
  const [calculatorD1PopupTop, setCalculatorD1PopupTop] = useState(0);
  const [calculatorRopPopupTop, setCalculatorRopPopupTop] = useState(0);
  const [calculatorRopdPopupTop, setCalculatorRopdPopupTop] = useState(0);
  const [calculatorRoplPopupTop, setCalculatorRoplPopupTop] = useState(0);
  const [point, setPoint] = useState(null);
  const [isUserInputPopup, setIsUserInputPopup] = useState(false);
  const [userDataInfo, setUserDataInfo] = useState(false);
  const [periodicalType, setPeriodicalType] = useState("monthly");
  const isUserInput = useRef(false);
  const [inputValue, setInputValue] = useState("");
  const [isStyleTagPresent, setIsStyleTagPresent] = useState(false); //Added for stylus tool text-spacing change
  const inValidInputStyle = {
    color: 'rgb(185, 0, 0)'
  }
  const checkUserInput = (event)=> {
  const regex = /^[a-zA-Z.&-']*$/;
        
    // Check if current value matches the allowed characters
    if (false && !regex.test(event.target.value)) {
        setUserDataInfo({"valid":0,"message":"Special characters allowed & - ' ."})
        document.querySelector(".user-input .btn_approve").style.pointerEvents = "none"
        document.querySelector(".user-input .btn_approve").style.opacity = "0.6"
    }
    else{
      setUserDataInfo(false);
      document.querySelector(".user-input .btn_approve").style.pointerEvents = "auto"
      document.querySelector(".user-input .btn_approve").style.opacity = "1"
    }
  }
  const updateInput = (e) => {
    // let regex = e.target.id == "qh" ? /^\d+(\.\d*)?$/ : /^\d*$/
    let regex = e.target.id == "qh" ? /^\d+(\.\d{0,2})?$/ : /^\d*$/
    let { name, value } = e.target;
    let res = 0;
    if(value.indexOf(".")!=-1){
     res = value.split(".")[1].length
    }
    let result = e.target.id == "qh" ? regex.test(parseFloat(value)) && parseFloat(value) <= 9999.99 && res<=2 : regex.test(value)
    if (['qd', 'qs', 'qh', 'dd', 'dw', 'ropd', 'ropl'].includes(name)) {
      if (result && !(name == "dw" && value == 0) && !(name == "qh" && value == 0) && !isNaN(value) || value === '') {
        setCalculator((prevCalculator) => ({
          ...prevCalculator,
          [name]: value,
        }));
      }
    } else {
      setCalculator((prevCalculator) => ({
        ...prevCalculator,
        [name]: value,
      }));
    }
  }
  const accordionPopupStyle = {
    PointerEvents: 'none',
    backgroundColor: "#fff"
  }
  const showDecisionPopup = () => {
    setIsDecisionPopup(true);
  }
  const hideDecisionPopup = () => {
    setIsDecisionPopup(false);
    var element = document.getElementById('RevenueGraph');
    element.style.overflow = 'hidden';
  }
  const saveUserData = (a)=> {
    let userData = a =="save" ? document.getElementById("userData").value : "DigiLife";
    save_userData({
      "id":simObj?.id,
      "executioninstanceid": simObj?.executioninstanceid,
      "attemptno": simObj?.attemptno,
      "userData": userData
    }).then((response)=>{
      if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
        setError(response?.data)
      }
    else{
      if (typeof response != 'undefined') {
        if(response?.data?.valid){
          let newSimObj = {
            ...response?.data, actions:
              response?.data.actions?.map((action) => ({
                ...action,
                type: "PlaceOrder",
                quantity: !(quantity) ? 50 : quantity,
                shippingType: shippingType
              }))
          }
          setSimObj(newSimObj);
          // window.$('.ui.tiny.modal.user-input').modal('hide');
          setIsModalVisible(false);
          window.$('.my-dimmer .ui.dimmer').dimmer("hide");
        }
        else{
          setUserDataInfo(response?.data)
        }  
      }
    }
    }).catch(()=>{
      // setError(errorMsg);
      setError({"id":"00000","msg":errorMsg})
    })
  }
  const loadNextPopup = () => {
    setSimPopup(false);
    setIsOverlay(false);
    setIsPopupShown(true);
    if (document.querySelector(".help-link") != null) {
      document.querySelector(".help-link").focus();
    }
  }
  const closeKpisPopup = () => {
    setKpisPopup(false);
    setPlPopup(true);
  }
  const closeExpandCalcPopup = () => {
    setIsFromHelp(false);
    setExpandCalcPopup(false);
    if (isCalculatorOpen) {
      setCalculatorPopup((prevCalculator) => ({
        ...prevCalculator,
        ["q"]: true
      }));
    }
    else {
      setSimPrgPopup(true);
    }
  }
  const closeAccordionPopup = () => {
    setAccordionPopup(false);
    setExpandCalcPopup(true);
  }


  const playSimulation = () => {
    setToggleSimulation(true);
    /*
    var profitLossElements = document.getElementsByClassName("profit-loss");
    var currentdaysElements = document.getElementsByClassName("currentdays");
    for (var i = 0; i < profitLossElements.length; i++) {
        profitLossElements[i].setAttribute("role", "alert");
    }
    for (var i = 0; i < currentdaysElements.length; i++) {
      currentdaysElements[i].setAttribute("role", "alert");
    }
    */
  }

  const resumeSimulation = () => {
    let runSimObj = {}
    for (let key in simObj) {
      if (!window.$.isArray(simObj[key])) {
        runSimObj[key] = simObj[key]
      }
    }
    if (!isRequestLoading) {
      setIsRequestLoading(true);
      play_simulation(simObj.sessionid, runSimObj).then((response) => {
        if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
          setError(response?.data)
        }
        else{
        if (typeof response != 'undefined') {
          let newSimObj = {
            ...response?.data, actions:
              response?.data.actions?.map((action) => ({
                ...action,
                type: "PlaceOrder",
                quantity: !(quantity) ? 50 : quantity,
                shippingType: shippingType
              }))
          }
          setSimObj(newSimObj);
          setIsShowPlaceOrder(false);
          setIsRequestLoading(false);
        }
      }
      }).catch((error) => {
        // setError(errorMsg);
        setError({"id":"00000","msg":errorMsg})
        console.log(error);
      })
    }
  }
  const placeOrder = () => {
    document.querySelector("#placeOrderButton").setAttribute("disabled", "disabled");
    document.querySelector("#playSumButton").setAttribute("disabled", "disabled");
    const pOrderObj = {
      "exinstanceid": simObj.executioninstanceid,
      "id": simObj.id,
      "currentstep": simObj.currentstep,
      "actions": simObj.actions.map((item) => ({ ...item, 'shippingType': (item.shippingType != "") ? item.shippingType : 'NORMAL_SHIPPING', 'quantity': (!item.quantity) ? 50 : item.quantity }))
    }
    place_order(pOrderObj, simObj.sessionid).then(function (response) {
      if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
        setError(response?.data)
}
else{
      let newSimObj = {
        ...response?.data, actions:
          response?.data.actions?.map((action) => ({
            ...action,
            type: "PlaceOrder",
            quantity: !(quantity) ? 50 : quantity,
            shippingType: shippingType
          }))
      }
      setSimObj(newSimObj);
      setIsShowPlaceOrder(true);
      document.querySelector("#playSumButton").removeAttribute("disabled");
      document.querySelector("#playSumButton").focus();
      let btnText = document.querySelector("#playSumButton").innerText;
      document.querySelector("#playSumButton").setAttribute("aria-label", btnText)
    }
    }).catch((error) => {
      // setError(errorMsg);
      setError({"id":"00000","msg":errorMsg})
      console.log(error);
    })
    setQuantity(50);
    setShippingType("NORMAL_SHIPPING");
    document.querySelector("#playSumButton").focus();
    // document.querySelector(".order-history table tbody").scrollTop = 0;
    document.querySelector(`.${ImModuleStyle['order-history']} table tbody`).scrollTop = 0;
  }
  const pauseSimulation = () => {
    setToggleSimulation(false);
    /*
    var profitLossElements = document.getElementsByClassName("profit-loss");
    var currentdaysElements = document.getElementsByClassName("currentdays");
    for (var i = 0; i < profitLossElements.length; i++) {
      profitLossElements[i].removeAttribute("role");
    }
    for (var i = 0; i < currentdaysElements.length; i++) {
      currentdaysElements[i].removeAttribute("role");
    }
    console.log("pasuse:" + simObj.currentstep)
    */
  }
  const fuSkipWalkThruPopups = () => {
    let readStatusLength = simObj?.artifacts?.filter((artifact) => artifact.readstatus == 1).length;
    if (simObj?.currentstep > 0 || simObj?.attemptno > 1 || readStatusLength > 0 || (simObj?.decisionHistory != null && simObj?.decisionHistory?.length > 0)) {
      skipWalkThruPopups(false);
    }
  }
  const initSimulation = () => {
    if (!isPopupShown) {
      setIsOverlay(true);
      setHeaderPopup(true)
    }
    setIsArtifacts(true);
  }
  useEffect(() => {
    initSimulation();
    window.$('.ui.accordion').accordion();
    window.$('html, body').animate({
      scrollTop: 0
    }, 100);
    // document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro").style.display = "none";
    document.title = "Inventory Management | Simulation";
    document.querySelector("header.header h1.title").focus();
    document.querySelector(".skip-to-main-content-link").style.display = "block";
    if (document.querySelector("#showSummary")) {
      document.querySelector("#showSummary").focus();
    }
    return () => {
      document.querySelector(".skip-to-main-content-link").style.display = "none";
    }
  }, []);
  useEffect(() => {
    fuSkipWalkThruPopups();
    if ((simObj?.laststate?.quantityordered != 0) && document.querySelector("#playSumButton") != null) {
      document.querySelector("#playSumButton").focus();
    }
  }, [simObj])
  useEffect(() => {
    if((simObj?.version ==1) || (simObj?.version > 1 && simObj?.laststate?.level)){
      if(simObj?.laststate?.level == "EASY"){
        setCalculator((prevCalculator) => ({
          ...prevCalculator,
          ["dw"]: simObj?.cal?.W ? simObj?.cal?.W : 1,
        }));
      }
    }
  }, [simObj?.cal]);
  useEffect(() => {
    if((simObj?.version ==1) || (simObj?.version > 1 && simObj?.laststate?.level)){
      if(simObj?.laststate?.level == "EASY"){
        setCalculator((prevCalculator) => ({
          ...prevCalculator,
          ["dw"]: simObj?.cal?.W ? simObj?.cal?.W : 1,
          qd: simObj?.cal?.D,
          qs: simObj?.cal?.S,
          qh: simObj?.cal?.H,
          dd: simObj?.cal?.D,
          ropd: simObj?.cal?.d,
          ropl: simObj?.cal?.L
        }));
      }
      else{
        setCalculator((prevCalculator) => ({
          ...prevCalculator,
          qd: simObj?.cal?.D,
          dd: simObj?.cal?.D,
          qh: simObj?.cal?.H,
          dw: simObj?.cal?.W
        }));
      }
      
    }
  }, [simObj?.cal?.D])
  
  useEffect(() => {
    if(calculator.dd !== "" && calculator.dw !== "" && calculator.dw !== 0) {
      const dailyDemand = Math.round(calculator.dd / calculator.dw);
      setCalculator((prev) => ({
        ...prev,
        ropd: dailyDemand
      }));
    } else {
      setCalculator((prev) => ({
        ...prev,
        ropd: 0
      }))
    }
  },[calculator.dd, calculator.dw]);

  const funMonthlyHandler = (e) => {
    setPeriodicalType("monthly");
    setIsDecisionPopup(false);
  }
  const funQuarterlyHandler = (e) => {
    setPeriodicalType("quarterly");
    setIsDecisionPopup(false);
  }
  const funYearlyHandler = (e) => {
    setPeriodicalType("yearly");
    setIsDecisionPopup(false);
  }

  const formatNum = (num) => {
    return num?.toLocaleString('en-US', { style: 'decimal' });
  }
  let maxOrders = 0;
  let minOrders = 0;
  simObj.actions?.map(function (action) {
    maxOrders = action.options.maxOrders;
    minOrders = action.options.minOrders;
  })
  useEffect(() => {
    class TabsManual {
      constructor(groupNode) {
        this.tablistNode = groupNode;

        this.tabs = [];

        this.firstTab = null;
        this.lastTab = null;

        this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
        this.tabpanels = [];

        for (var i = 0; i < this.tabs.length; i += 1) {
          var tab = this.tabs[i];
          var tabpanel = document.getElementById(tab.getAttribute('aria-controls'));

          tab.tabIndex = -1;
          tab.setAttribute('aria-selected', 'false');
          this.tabpanels.push(tabpanel);

          tab.addEventListener('keydown', this.onKeydown.bind(this));
          tab.addEventListener('click', this.onClick.bind(this));

          if (!this.firstTab) {
            this.firstTab = tab;
          }
          this.lastTab = tab;
        }

        this.setSelectedTab(this.firstTab);
      }

      setSelectedTab(currentTab) {
        for (var i = 0; i < this.tabs.length; i += 1) {
          var tab = this.tabs[i];
          if (currentTab === tab) {
            tab.setAttribute('aria-selected', 'true');
            tab.removeAttribute('tabindex');
            //this.tabpanels[i].classList.remove('is-hidden');
          } else {
            tab.setAttribute('aria-selected', 'false');
            tab.tabIndex = -1;
            //this.tabpanels[i].classList.add('is-hidden');
          }
        }
      }

      moveFocusToTab(currentTab) {
        currentTab.focus();
      }

      moveFocusToPreviousTab(currentTab) {
        var index;

        if (currentTab === this.firstTab) {
          this.moveFocusToTab(this.lastTab);
        } else {
          index = this.tabs.indexOf(currentTab);
          this.moveFocusToTab(this.tabs[index - 1]);
        }
      }

      moveFocusToNextTab(currentTab) {
        var index;

        if (currentTab === this.lastTab) {
          this.moveFocusToTab(this.firstTab);
        } else {
          index = this.tabs.indexOf(currentTab);
          this.moveFocusToTab(this.tabs[index + 1]);
        }
      }

      /* EVENT HANDLERS */

      onKeydown(event) {
        var tgt = event.currentTarget,
          flag = false;

        switch (event.key) {
          case 'ArrowLeft':
            this.moveFocusToPreviousTab(tgt);
            flag = true;
            break;

          case 'ArrowRight':
            this.moveFocusToNextTab(tgt);
            flag = true;
            break;

          case 'Home':
            this.moveFocusToTab(this.firstTab);
            flag = true;
            break;

          case 'End':
            this.moveFocusToTab(this.lastTab);
            flag = true;
            break;

          default:
            break;
        }

        if (flag) {
          event.stopPropagation();
          event.preventDefault();
        }
      }

      // Since this example uses buttons for the tabs, the click onr also is activated
      // with the space and enter keys
      onClick(event) {
        this.setSelectedTab(event.currentTarget);
      }
    }
    const initTabs = () => {
      var tablists = document.querySelectorAll('[role=tablist].Graphs');
      for (var i = 0; i < tablists.length; i++) {
        new TabsManual(tablists[i]);
      }
      if (document.querySelectorAll('.Graphs button') != null) {
        const elementsWithClassGraphs = document.querySelectorAll('.Graphs button');
        elementsWithClassGraphs.forEach(element => {
          if (element.getAttribute('aria-selected') === 'false') {
            element.setAttribute('tabindex', '-1');
          }
        });
      }
    }
    initTabs()
  }, [])
  const openNewWindow = (data) => {
    const newWindow = window.open('', '_blank', 'width=800,height=800');
    if (newWindow) {
      newWindow.document.open();
      const htmlContentWithNbsp = `
<!DOCTYPE html>
<html>
<head>
    <title>Inventory Management</title>
    <link rel="stylesheet" type="text/css" href="https://cdn.datatables.net/1.13.6/css/jquery.dataTables.min.css">
    <style>
          .MainDiv {
              min-height: 620px;
              overflow: hidden;
              width: 95%;
              margin: 0 auto;
          }
          .MainDivChild {
              overflow-x: auto;
              margin: 10px auto;
          }
          table.dataTable thead th {
            border: 1px solid rgba(0, 0, 0, 0.3);
            background-color: #f0f0f0;
          }
          .dataTables_length {
              min-width: 5.5em;
              padding: 10px;
          }
          .dataTables_filter {
            min-width: 5.5em;
            padding: 10px;
            text-align: left;
          }
          .table {
              width: 100%;
              max-width: 100%;
              margin-bottom: 20px;
          }
          .headingh3 {
              color: #002D5F;
              font-weight: 700;
              font-size: 22px;
              background: transparent;
              padding: 0;
          }
          header.header {
            box-shadow: 0px 1px 2px 0px #CCCCCC;
            color: #012F61;
            position: relative;
          }
          header.header>.container {
            margin: 0px 20px;
            display: flex;
            justify-content: space-between;
            min-height: 60px;
            align-items: center;
          }
          header.header>.container h1 {
            display: flex;
            justify-content: center;
            align-items: center;
            color: #b2347b;
          }
          table.dataTable thead th {
              color: #002D5F;
          }
          .header-container header {
          font-size: 12px;
          color: #b2347b;
          }
          .footer {
              background-color: #CDCDCD;
              font-size: 12px;
              padding: 6px;
              text-align: center;
              color: #000000;
          }
          .footer .container {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 82.5%;
              margin: auto;
          }
          .footer .container>div {
              display: flex;
          }
          .footer-links {
              list-style-type: none;
              padding-left: 0;
              padding: 0 5px;
              margin: 0;
              display: flex;
          }
          .footer-links .listitem a {
              text-decoration: underline;
              color: #000000;
          }
          #RevenueGraphData th {
            padding: 4px; 
          }
          #RevenueGraphData tr td:first-child {
            width: 45px; 
          }
    </style>
</head>
<body style="font: 16px/26px 'Roboto', 'Helvetica Neue', Helvetica, Arial; -webkit-font-smoothing: antialiased; font-weight: 300;margin:0;">
<div id="new-component-root"></div>
<script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js"></script>
<script src="https://cdn.datatables.net/1.13.6/js/jquery.dataTables.min.js"></script>
<script>
    document.addEventListener('DOMContentLoaded', function() {
        $('#RevenueGraphData').DataTable({
            pagingType: 'full_numbers'
        });
        $('#InventoryGraphData').DataTable({
            pagingType: 'full_numbers'
        });
    });
</script>
</body>
</html>
`;
      const htmlContentWithoutNbsp = htmlContentWithNbsp.replace(/&nbsp;/g, ' ');


      newWindow.document.write(htmlContentWithoutNbsp);
      ReactDOM.render(<GraphDataTable type={periodicalType} simObj={simObj} setSimObj={setSimObj} />, newWindow.document.getElementById("new-component-root"));
      newWindow.document.close();
    }
  };
  
  // Reset the user input field to the default placeholder
  function resetUserDataInput() {
    window.$('.user-data-input').val(''); // Clear the input field
    window.$('.user-data-input').attr('placeholder', 'DigiLife'); // Reset placeholder
  }
  // Listen for the custom event to reset the input
  document.addEventListener('resetUserDataInput', resetUserDataInput);

  window.$(document).off('keyup keydown', '.user-input #userData').on('keyup keydown','.user-input #userData', function(e) {
    checkUserInput(e);
  });
  window.$(document).off('click touchstart', '.custom-modal .ui.btn_cancel.button').on('click touchstart','.custom-modal .ui.btn_cancel.button', function(e) {
    e.stopPropagation();
    saveUserData("skip");
  });
  window.$(document).off('click touchstart', '.custom-modal .ui.btn_approve.button').on('click touchstart','.custom-modal .ui.btn_approve.button', function(e) {
    e.stopPropagation();
    saveUserData("save");
  });
  // useEffect(() => {
  //   if((simObj?.hasOwnProperty("userData") && simObj?.userData == "") && (simObj?.hasOwnProperty("version") && simObj?.version > 1)){
  //     if(window.$(".ui.dimmer .user-input").length > 1){
  //       window.$(".ui.dimmer .user-input:last").remove();
  //     }
  //     window.$('.ui.tiny.modal.user-input').modal({
  //       closable: false
  //     }).modal('show');
  //     isUserInput.current = true;
  //     // setIsUserInputPopup(false);
  //   }
  // },[simObj])

  // useEffect(()=>{
  //   if(simObj?.hasOwnProperty("userData") && (simObj?.hasOwnProperty("version") && simObj?.version > 1)){
  //     if(isUserInput.current){
  //       if(window.$(".ui.dimmer .user-input").length > 0){
  //         focusPopUp(".user-input");
  //         document.querySelector(".user-input input").removeAttribute("tabindex");
  //         document.querySelector(".user-input input").focus();
  //         document.querySelectorAll(".user-input button").forEach((item)=>{
  //             item.removeAttribute("tabindex")
  //         });
  //       }
  //     }
  //   }
  // },[simObj,isUserInput.current])

  useEffect(()=>{
    if(simObj?.hasOwnProperty("userData") && (simObj?.hasOwnProperty("version") && simObj?.version > 1)){
        setTimeout(() => {
          if(simObj?.userData == ""){
            if(document.querySelector(".ui.pointing.label")){
              document.querySelectorAll(".ui.pointing.label button").forEach((item)=>{
                item.setAttribute("tabindex","-1");
              })
            }
          }
          else{
            if(document.querySelector(".ui.pointing.label")){
              document.querySelectorAll(".ui.pointing.label button").forEach((item)=>{
                item.removeAttribute("tabindex");
              })
              document.querySelector(".ui.pointing.label").setAttribute("tabindex","0");
              document.querySelector(".ui.pointing.label").focus();
            }
          }
        }, 100);
    }
  },[simObj?.userData])

  useEffect(() => {
    if((simObj?.hasOwnProperty("userData") && simObj?.userData == "") && (simObj?.hasOwnProperty("version") && simObj?.version > 1) && headerPopup){
      setIsModalVisible(true);
      window.$('.my-dimmer .ui.dimmer').dimmer({
        closable: false // Prevent closing when clicked
      }).dimmer('show');
      isUserInput.current = true;
    }
  }, [simObj, headerPopup]);

  useEffect(() => {
    if (isModalVisible) {
      if (document.querySelector('.custom-modal')) {
        focusPopUp(".custom-modal");
        document.querySelector(".custom-modal input").removeAttribute("tabindex");
          document.querySelector(".custom-modal input").focus();
          document.querySelectorAll(".custom-modal button").forEach((item)=>{
              item.removeAttribute("tabindex")
          });
      }
    }
  }, [isModalVisible]);

  useEffect(() => {
    const handleResize = ()=> {
        if(calculatorPopup?.q && document.getElementsByClassName(`${ImModuleStyle['calc-custom']}`)[0] != null){
            let top = document.getElementsByClassName(`${ImModuleStyle['calc-custom']}`)[0].clientHeight;
            setCalculatorQPopupTop(-top);
        }
        if((calculatorPopup?.qd || calculatorPopup?.d) && document.getElementsByClassName(`${ImModuleStyle['calc-custom1']}`)[0] != null){
            let top = document.getElementsByClassName(`${ImModuleStyle['calc-custom1']}`)[0].clientHeight + document.querySelector(`.accordion .show`).clientHeight + 15;
            setCalculatorQdPopupTop(-top);
        }
        if(calculatorPopup?.qs && document.getElementsByClassName(`${ImModuleStyle['calc-custom2']}`)[0] != null){
            let top = document.getElementsByClassName(`${ImModuleStyle['calc-custom2']}`)[0].clientHeight + document.querySelector(`.accordion .show`).clientHeight + 15;
            setCalculatorQsPopupTop(-top);
        }
        if(calculatorPopup?.qh && document.getElementsByClassName(`${ImModuleStyle['calc-custom3']}`)[0] != null){
            let top = document.getElementsByClassName(`${ImModuleStyle['calc-custom3']}`)[0].clientHeight;
            setCalculatorQhPopupTop(-top);
        }
        if(calculatorPopup?.q1 && document.getElementsByClassName(`${ImModuleStyle['calc-custom4']}`)[0] != null){
            let top = document.getElementsByClassName(`${ImModuleStyle['calc-custom4']}`)[0].clientHeight;
            setCalculatorQ1PopupTop(-top);
        }
        if(calculatorPopup?.dd && document.getElementsByClassName(`${ImModuleStyle['division-calc-custom1']}`)[0] != null){
            let top = document.getElementsByClassName(`${ImModuleStyle['division-calc-custom1']}`)[0].clientHeight + document.querySelector(`.accordion .show`).clientHeight + 15;
            setCalculatorDdPopupTop(-top);
        }
        // if(calculatorPopup?.dw && document.getElementsByClassName(`${ImModuleStyle['division-calc-custom2']}`)[0] != null){
        //     let top = document.getElementsByClassName(`${ImModuleStyle['division-calc-custom2']}`)[0].clientHeight - 5;
        //     setCalculatorDwPopupTop(-top);
        // }
        if(calculatorPopup?.d1 && document.getElementsByClassName(`${ImModuleStyle['division-calc-custom3']}`)[0] != null){
            let top = document.querySelector(`.accordion .show`).clientHeight;
            setCalculatorD1PopupTop(top);
        }
        if(calculatorPopup?.rop && document.getElementsByClassName(`${ImModuleStyle['multi-calc-custom']}`)[0] != null){
            let top = document.querySelector(`.accordion .show`).clientHeight;
            setCalculatorRopPopupTop(top);
        }
        if(calculatorPopup?.ropd && document.getElementsByClassName(`${ImModuleStyle['multi-calc-custom1']}`)[0] != null){
            let top = document.getElementsByClassName(`${ImModuleStyle['multi-calc-custom1']}`)[0].clientHeight + document.querySelector(`.accordion .show`).clientHeight + 15;
            setCalculatorRopdPopupTop(-top);
        }
        if(calculatorPopup?.ropl && document.getElementsByClassName(`${ImModuleStyle['multi-calc-custom2']}`)[0] != null){
            let top = document.getElementsByClassName(`${ImModuleStyle['multi-calc-custom2']}`)[0].clientHeight + document.querySelector(`.accordion .show`).clientHeight + 10;
            setCalculatorRoplPopupTop(-top);
        }
    }
    window.addEventListener('resize', handleResize);
    handleResize();
  }, [calculatorPopup?.q, calculatorPopup?.qd, calculatorPopup?.qs, calculatorPopup?.qh, calculatorPopup?.q1, calculatorPopup?.dd, calculatorPopup?.dw, calculatorPopup?.d1, calculatorPopup?.rop, calculatorPopup?.ropd, calculatorPopup?.ropl]);

  //Added for stylus tool
  useEffect(() => {
    const checkStyleTag = () => {
      const styleTag = document.querySelector('style.stylus');
      setIsStyleTagPresent(!!styleTag);  // Updates the state to true if the tag is found, false otherwise
    };

    // Call the check function when the component mounts
    checkStyleTag();

    // Optionally, if the tag might be dynamically added, use a MutationObserver or setInterval
    const intervalId = setInterval(checkStyleTag, 500); // Check every 500ms
    return () => clearInterval(intervalId);  // Clean up interval when component unmounts
  }, []);

  return (
    <motion.div className={`${ImModuleStyle.simulation} ${ImModuleStyle.container}`} id={`${isStyleTagPresent ? `${ImModuleStyle['stylusProfitLossBlock']}` : ''}`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
      <div className={`${ImModuleStyle.introtext}`}>
        <h2 className={`${ImModuleStyle.heading} ${ImModuleStyle.bgpurple} ${ImModuleStyle.imSim}`}>Simulation</h2>
        <p>You can place a maximum order of {maxOrders} units in multiples of {minOrders}. The larger your order,
          the higher your
          holding costs. However, smaller orders mean more frequent re-ordering costs.</p>
        {/* Click &nbsp;
          <Link to={`${rootRoute}/${simType?.toLowerCase()}?from=simulation`} style={{'color':'#000','text-decoration':'underline','font-weight':'bold'}}>
          <em className="info circle icon" aria-hidden="true" role="presentation"></em>
          <span>here</span>
        </Link>
        &nbsp;to revisit the tutorial.</p> */}
      </div>
      <hr aria-hidden="true" role="presentation" />
      <CalProfitLoss popupState={[simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, accordionPopup, setAccordionPopup, simObj, setSimObj, formatNum, toggleSimulation, kpisPopup, setKpisPopup, isCalculatorOpen, closeKpisPopup]} />
      <div className={`ui vertical accordion menu ${ImModuleStyle.ui} ${ImModuleStyle.vertical} ${ImModuleStyle.accordion} ${ImModuleStyle.menu}`} style={{ width: "auto" }}>
        <div className={`item ${ImModuleStyle.item}`}>
          <a href="#" role='button' className={`${ImModuleStyle['calc-help-link']}`} style={{ display: "none" }} onClick={() => {
            setToggleSimulation(false);
            setCalculatorPopup((prevCalculator) => ({
              ...prevCalculator,
              ["q"]: true
            }));
            // isFromHelp ? setIsOverlay(true) : setIsOverlay(false)
            setIsOverlay(true);
            setIsFromHelp(true);
          }}>
            <img className={`${ImModuleStyle['image']} ${ImModuleStyle['calc-help']}`} src={help} alt="Calculator Help" />
          </a>
          <button className={`title ui label ${ImModuleStyle.title} ${ImModuleStyle.ui} ${ImModuleStyle.label} ${calculatorPopup?.cal ? "show" : ""}`} style={{ pointerEvents: accordionPopup || calculatorPopup?.cal ? "none" : "auto", position: accordionPopup || calculatorPopup?.cal ? "relative" : "static", backgroundColor: accordionPopup || calculatorPopup?.cal ? "#fff" : "#c3c3c324", zIndex: accordionPopup || calculatorPopup?.cal ? 2 : "auto" }}
            onClick={(e) => {
              setIsFromHelp(true);
              setIsCalculatorOpen(!isCalculatorOpen);
              setAccordion_Popup(prevState => !prevState);
              const currTarget = (e.target.hasAttribute("aria-expanded")) ? e.target : e.target.parentNode;
              if (currTarget.classList.contains(ImModuleStyle.active)) {
                currTarget.classList.remove(ImModuleStyle.active);
                window.$(currTarget).closest(".ui.accordion").find(".content")[0].classList.remove(ImModuleStyle.active)
                setTimeout(() => {
                  window.$(currTarget).closest(".ui.accordion").find(".content")[0].classList.remove("active")
                  window.$(currTarget).closest(".ui.accordion").find(`.content .${ImModuleStyle['equation-sections']}`).addClass("hidden");
                }, 300);
                currTarget.classList.remove("active")
                window.$(currTarget).closest(".ui.accordion").find(`.${ImModuleStyle['calc-help-link']}`)[0].style.display = "none"
              }
              else {
                currTarget.classList.add(ImModuleStyle.active);
                window.$(currTarget).closest(".ui.accordion").find(".content")[0].classList.add(ImModuleStyle.active)
                setTimeout(() => {
                  window.$(currTarget).closest(".ui.accordion").find(".content")[0].classList.add("active");
                  window.$(currTarget).closest(".ui.accordion").find(`.content .${ImModuleStyle['equation-sections']}`).removeClass("hidden");
                }, 300);
                currTarget.classList.add("active");
                window.$(currTarget).closest(".ui.accordion").find(`.${ImModuleStyle['calc-help-link']}`)[0].style.display = "block"
              }
            }}
            aria-expanded={accordion_Popup}>
            Calculator
            <i className={`chevron down icon ${ImModuleStyle.icon} ${expandCalcPopup ? "show" : ""}`}></i>
          </button>
          {
            accordionPopup ? <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label}`} role='dialog' aria-modal="true" aria-label="Calculator popup" tabIndex={-1}>
              <p>You may want to use the calculator to figure out what your Economic Order Quantity (Q) and Reorder Point (ROP) should be.</p>
              <div className={`${ImModuleStyle.mt10} ${ImModuleStyle.dflex}`} >
                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                <Button btnName="Next" btnId="btnNext" btnParentClassName={`${ImModuleStyle.ml10}`} btnWidth="80" clickEventHandler={closeAccordionPopup} />
              </div>
            </div> : ''
          }
          {
            expandCalcPopup ? <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['expand-calc-popup']}`} role='dialog' aria-modal="true" aria-label="Expand calculator popup" tabIndex={-1}>
              <p>Expand the Calculator, then click the "?" to access a tutorial on how to use this tool.</p>
              <div className={`${ImModuleStyle.mt10} ${ImModuleStyle.dflex}`} >
                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                <Button btnName="Next" btnId="btnNext" btnParentClassName={`${ImModuleStyle.ml10}`} btnWidth="80" clickEventHandler={closeExpandCalcPopup} />
              </div>
            </div> : ''
          }

          <div className={`content ${ImModuleStyle.content}`}>
            <div className={`${ImModuleStyle['equation-sections']}`}>
              <div className={`${ImModuleStyle["simulation-sqrt"]} ${ImModuleStyle['sqrt-sec']} ${(calculatorPopup?.q || calculatorPopup?.q1) ? "show" : ""}`}>
                <div className={`${ImModuleStyle['lhs']}`}>
                  <div>
                    <span className="sr-only">
                      Q is the Economic Order Quantity. It tells you how much to order.
                    </span>
                    <span className={`${ImModuleStyle['lhs-span2']}`} data-position="bottom left" data-tooltip='Q is the Economic Order Quantity. It tells you how much to order.'>
                      Q
                    </span>
                    <span>&nbsp;&nbsp;=</span>
                  </div>
                </div>
                <div className={`${ImModuleStyle['rhs']}`}>
                  <svg height="80" width="235" viewport="0 0 110 300" aria-label="square root" role='img'>
                    <line x1="0" y1="60" x2="8" y2="60" style={{ "stroke": "gray", "strokeWidth": 1 }}></line>
                    <line x1="8" y1="60" x2="15" y2="80" style={{ "stroke": "gray", "strokeWidth": 1 }}></line>
                    <line x1="15" y1="80" x2="30" y2="0" style={{ "stroke": "gray", "strokeWidth": 1 }}></line>
                    <line x1="30" y1="0" x2="235" y2="0" style={{ "stroke": "gray", "strokeWidth": 2 }}></line>
                  </svg>
                  <div className={`${ImModuleStyle['equation']}`}>
                    <div>
                      <div style={{"position":"relative"}}>2
                        <span className={`${ImModuleStyle['cross']}`} aria-label='multiplied by'><span aria-hidden={true}>x</span></span>
                        <div className={`ui labeled input ${ImModuleStyle['ui']} ${ImModuleStyle['labeled']} ${ImModuleStyle['input']} ${calculatorPopup?.qd ? "show" : ""}`}>
                          <div className={`ui label ${ImModuleStyle['ui']} ${ImModuleStyle['label']}`} aria-label='D is annual demand, the amount of product sold per year. This number is given to you.'>
                            <label htmlFor='qd' aria-hidden="true" data-tooltip="D is annual demand, the amount of product sold per year. This number is given to you." data-position="bottom center">D</label>
                          </div>
                          <input type="text" autoComplete="off" id='qd' name="qd" style={{ "width": "50px" }} maxlength="5" value={calculator.qd} onChange={updateInput} />
                        </div>
                        {
                          calculatorPopup?.qd && <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['calc-custom1']}`} role='dialog' aria-modal="true" aria-label="Annual demand details popup" tabIndex={-1} style={{top: calculatorQdPopupTop+"px"}}>
                            <p>
                              D is annual demand, the amount of product sold per year. This is a read only field, and it will be calculated automatically.
                            </p>
                            <div className={`mt10 dflex`}>
                              <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                              <Button btnName="Next" btnParentClassName={`ml10`} btnId="btnNext1" btnWidth="80" clickEventHandler={() => {
                                setCalculatorPopup((prevCalculator) => ({
                                  ...prevCalculator,
                                  ["qd"]: false,
                                  ["qs"]: true
                                }));
                              }} />
                            </div>
                          </div>
                        }
                        <span className={`${ImModuleStyle['cross']}`} aria-label='multiplied by'><span aria-hidden={true}>x</span></span>
                        <div className={`ui labeled input ${ImModuleStyle['ui']} ${ImModuleStyle['labeled']} ${ImModuleStyle['input']} ${calculatorPopup?.qs ? "show" : ""}`}>
                          <div className={`ui label ${ImModuleStyle['ui']} ${ImModuleStyle['label']}`} aria-label='S is Setup Cost, how much it costs to order and deliver the product. This is a constant price you can find in the documents at the top right.' >
                            <label htmlFor='qs' aria-hidden="true" data-tooltip="S is Setup Cost, how much it costs to order and deliver the product. This is a constant price you can find in the documents at the top right." data-position="bottom center">S</label>
                          </div>
                          <input id='qs' name="qs" autoComplete="off" type="text" maxlength="4" value={calculator.qs} onChange={updateInput} />
                        </div>
                        {
                          calculatorPopup?.qs && <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['calc-custom2']}`} role='dialog' aria-modal="true" aria-label="Setup cost popup" tabIndex={-1} style={{top: calculatorQsPopupTop+"px"}}>
                            <p>
                              S is Setup Cost, how much it costs to order and deliver the product. This is a constant price you can find in the documents at the top right.
                            </p>
                            <div className={`mt10 dflex`}>
                              <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                              <Button btnName="Next" btnParentClassName={`ml10`} btnId="btnNext1" btnWidth="80" clickEventHandler={() => {
                                setCalculatorPopup((prevCalculator) => ({
                                  ...prevCalculator,
                                  ["qs"]: false,
                                  ["qh"]: true
                                }));
                              }} />
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                    <span aria-label='divided by'><hr role='presentation' aria-hidden={true} /></span>

                    <div>
                      <div className={`ui labeled input ${ImModuleStyle['ui']} ${ImModuleStyle['labeled']} ${ImModuleStyle['input']} ${calculatorPopup?.qh ? "show" : ""}`}>
                        <div className={`ui label ${ImModuleStyle['ui']} ${ImModuleStyle['label']}`} aria-label='This is Holding Cost, or how much it costs to hold the inventory of the product.  It is a daily cost.  This is a constant price you can find in the documents at the top right, multiplied by the number of days remaining.'>
                          <label htmlFor='qh' aria-hidden="true" data-tooltip="This is Holding Cost, or how much it costs to hold the inventory of the product.  It is a daily cost.  This is a constant price you can find in the documents at the top right, multiplied by the number of days remaining." data-position="bottom center">H</label>
                        </div>
                        <input id='qh' name="qh" autoComplete="off" type="text" value={calculator.qh} maxlength="7" onChange={updateInput} />
                      </div>
                      {
                        calculatorPopup?.qh && <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['calc-custom3']}`} role='dialog' aria-modal="true" aria-label="Holding cost popup" tabIndex={-1} style={{top: calculatorQhPopupTop+"px"}}>
                          <p>
                          This is Holding Cost, or how much it costs to hold the inventory of the product.  It is a daily cost.  This is a constant price you can find in the documents at the top right, multiplied by the number of days remaining.
                          </p>
                          <div className={`mt10 dflex`}>
                            <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                            <Button btnName="Next" btnParentClassName={`ml10`} btnId="btnNext1" btnWidth="80" clickEventHandler={() => {
                              setCalculatorPopup((prevCalculator) => ({
                                ...prevCalculator,
                                ["qh"]: false,
                                ["q1"]: true
                              }));
                            }} />
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <div className={`${ImModuleStyle['result']}`}>
                  <p><span className={`${ImModuleStyle['equalSign']}`}>=</span><span id='qResult' style={{ "width": "47px" }}>
                    {
                      String(Math.round((calculator.qd !== "" && calculator.qs !== "" && calculator.qh !== "") && Math.sqrt(2 * calculator.qd * calculator.qs / calculator.qh) != "Infinity" && !Number.isNaN(Math.sqrt(2 * calculator.qd * calculator.qs / calculator.qh)) ? Math.sqrt(2 * calculator.qd * calculator.qs / calculator.qh) : Number.isNaN(Math.sqrt(2 * calculator.qd * calculator.qs / calculator.qh))? 0:""))
                    }</span></p>
                </div>
              </div>
              {
                calculatorPopup?.q && <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['calc-custom']}`} role='dialog' aria-modal="true" aria-label="Economic order quantity popup" tabIndex={-1} style={{top: calculatorQPopupTop+"px"}}>
                  <p>
                    Q is the Economic Order Quantity. It tells you how much to order.
                  </p>
                  <div className={`mt10 dflex`}>
                    <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                    <Button btnName="Next" btnParentClassName={`ml10`} btnId="btnNext1" btnWidth="80" clickEventHandler={() => {
                      setCalculatorPopup((prevCalculator) => ({
                        ...prevCalculator,
                        ["q"]: false,
                        ["qd"]: true
                      }));
                    }} />
                  </div>
                </div>
              }
              {
                calculatorPopup?.q1 && <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['calc-custom4']}`} role='dialog' aria-modal="true" aria-label="EOQ calculation popup" tabIndex={-1} style={{top: calculatorQ1PopupTop+"px"}}>
                  <p>
                    Plug in your constant Set up cost (S), and your constant Holding Cost (H) to run this calculation. Q tells you how much should order.
                  </p>
                  <div className={`mt10 dflex`}>
                    <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                    <Button btnName="Next" btnParentClassName={`ml10`} btnId="btnNext1" btnWidth="80" clickEventHandler={() => {
                      setCalculatorPopup((prevCalculator) => ({
                        ...prevCalculator,
                        ["q1"]: false,
                        ["d"]: true
                      }));
                    }} />
                  </div>
                </div>
              }
              <div className={`${ImModuleStyle['division-sec']}`} style={{"position":"relative"}}>
                <div className={`${(calculatorPopup?.d || calculatorPopup?.d1) ? "show" : ""}`} >
                  <div className={`${ImModuleStyle['lhs']}`} style={{ "width": "25px" }}>
                    {/* <p aria-description='d is estimated Daily Demand. If you notice demand being higher or lower, that may affect when you want to reorder.'>
                    <span data-tooltip="d is estimated Daily Demand. If you notice demand being higher or lower, that may affect when you want to reorder." data-position="bottom center">d</span>
                    &nbsp;&nbsp;=
                  </p> */}

                    <div>
                      <span className="sr-only">
                        d is estimated Daily Demand. If you notice demand being higher or lower, that may affect when you want to reorder.
                      </span>
                      <span className={`${ImModuleStyle['lhs-span2']}`} data-position="bottom center" data-tooltip='d is estimated Daily Demand. If you notice demand being higher or lower, that may affect when you want to reorder.'>
                        d
                      </span>
                      <span>&nbsp;&nbsp;=</span>
                    </div>
                  </div>
                  <div className={`${ImModuleStyle['rhs']}`}>
                    <div className={`${ImModuleStyle['equation']}`}>
                      <div style={{"position":"relative"}}>
                        <div className={`ui labeled input ${ImModuleStyle['ui']} ${ImModuleStyle['labeled']} ${ImModuleStyle['input']} ${calculatorPopup?.dd ? "show" : ""}`}>
                          <div className={`ui label ${ImModuleStyle['ui']} ${ImModuleStyle['label']}`} aria-label='D is annual demand, the amount of product sold per year. This number is given to you.' >
                            <label htmlFor='dd' aria-hidden="true" data-tooltip="D is annual demand, the amount of product sold per year. This number is given to you." data-position="bottom center">D</label>
                          </div>
                          <input id='dd' name="dd" autoComplete="off" type="text" style={{ "width": "50px" }} maxlength="5" value={calculator.dd} onChange={updateInput} />
                        </div>
                        {
                          calculatorPopup?.dd && <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['division-calc-custom1']}`} role='dialog' aria-modal="true" aria-label="Annual demand popup" tabIndex={-1} style={{top: calculatorDdPopupTop+"px"}}>
                            <p>
                              D is Annual Demand from before here. This is a read only field, and will be calculated automatically.
                            </p>
                            <div className={`mt10 dflex`}>
                              <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                              <Button btnName="Next" btnParentClassName={`ml10`} btnId="btnNext1" btnWidth="80" clickEventHandler={() => {
                                setCalculatorPopup((prevCalculator) => ({
                                  ...prevCalculator,
                                  ["dd"]: false,
                                  ["dw"]: true
                                }));
                              }} />
                            </div>
                          </div>
                        }
                      </div>
                      <span aria-label='divided by'><hr role='presentation' aria-hidden={true} /></span>
                      <div>
                        <div className={`ui labeled input ${ImModuleStyle['ui']} ${ImModuleStyle['labeled']} ${ImModuleStyle['input']}  ${calculatorPopup?.dw ? "show" : ""}`}>
                          <div className={`ui label ${ImModuleStyle['ui']} ${ImModuleStyle['label']}`} aria-label='W is work days remaining in the cycle. At the start of the year, W is 365, but this changes as you move through the selling cycle.' >
                            <label htmlFor='dw' aria-hidden="true" data-tooltip="W is work days remaining in the cycle. At the start of the year, W is 365, but this changes as you move through the selling cycle." data-position="bottom center">W</label>
                          </div>
                          <input id='dw' name="dw" autoComplete="off" type="text" maxlength="3" value={calculator.dw} onChange={updateInput} />
                        </div>
                        {
                          calculatorPopup?.dw && <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['division-calc-custom2']}`} role='dialog' aria-modal="true" aria-label="Work days remaining popup" tabIndex={-1} >
                            <p>
                              W is work days remaining in the cycle. At the start of the year, W is 365, but this changes as you move through the selling cycle.
                            </p>
                            <div className={`mt10 dflex`}>
                              <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                              <Button btnName="Next" btnParentClassName={`ml10`} btnId="btnNext1" btnWidth="80" clickEventHandler={() => {
                                setCalculatorPopup((prevCalculator) => ({
                                  ...prevCalculator,
                                  ["dw"]: false,
                                  ["d1"]: true
                                }));
                              }} />
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  <div className={`${ImModuleStyle['result']}`}>
                    <p><span className={`${ImModuleStyle['equalSign']}`}>=</span><span id='dResult' style={{ "width": "47px" }}>
                      {
                        String(Math.round(((calculator.dd !== "" && calculator.dw !== "") && (calculator.dd / calculator.dw) != "Infinity" && !Number.isNaN(calculator.dd / calculator.dw)) ? (calculator.dd / calculator.dw) : (Number.isNaN(calculator.dd / calculator.dw) && (calculator.dd !== "" && calculator.dw !== "")) ? 0 : ""))
                      }
                    </span></p>
                  </div>
                </div>
                {
                  calculatorPopup?.d && <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['division-calc-custom']}`} role='dialog' aria-modal="true" aria-label="Estimated daily demand popup" tabIndex={-1} style={{top: calculatorQdPopupTop+"px"}}>
                    <p>
                      d is estimated Daily Demand. If you notice demand being higher or lower, that may affect when you want to reorder.
                    </p>
                    <div className={`mt10 dflex`}>
                      <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                      <Button btnName="Next" btnParentClassName={`ml10`} btnId="btnNext1" btnWidth="80" clickEventHandler={() => {
                        setCalculatorPopup((prevCalculator) => ({
                          ...prevCalculator,
                          ["d"]: false,
                          ["dd"]: true
                        }));
                      }} />
                    </div>
                  </div>
                }
                {
                calculatorPopup?.d1 && <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['division-calc-custom3']}`} role='dialog' aria-modal="true" aria-label="Daily demand calculation popup" tabIndex={-1} style={{top: calculatorD1PopupTop+"px"}}>
                  <p>
                    To get d, divide Annual Demand (D) by Working Days remaining (W).
                  </p>
                  <div className={`mt10 dflex`}>
                    <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                    <Button btnName="Next" btnParentClassName={`ml10`} btnId="btnNext1" btnWidth="80" clickEventHandler={() => {
                      setCalculatorPopup((prevCalculator) => ({
                        ...prevCalculator,
                        ["d1"]: false,
                        ["rop"]: true
                      }));
                    }} />
                  </div>
                </div>
              }
              </div>

              
              <div className={`${ImModuleStyle["simulation-multiply-block"]} ${ImModuleStyle['multi-sec']}`} style={{"position":"relative"}}>
                <div className={`${calculatorPopup?.rop ? "show" : ""}`}>
                <div className={`${ImModuleStyle['lhs']}`}>
                  {/* <p aria-description='ROP is your Reorder Point. This is important! It tells you when to place a new order.'><span data-tooltip="ROP is your Reorder Point. This is important! It tells you when to place a new order." data-position="bottom center">ROP</span>&nbsp;&nbsp;=</p> */}

                  <div>
                    <span className="sr-only">
                      ROP is your Reorder Point. This is important! It tells you when to place a new order.
                    </span>
                    <span className={`${ImModuleStyle['lhs-span2']}`} data-position="bottom center" data-tooltip='ROP is your Reorder Point. This is important! It tells you when to place a new order.'>
                      ROP
                    </span>
                    <span>&nbsp;&nbsp;=</span>
                  </div>
                </div>
                <div className={`${ImModuleStyle['rhs']}`}>
                  <div style={{"position":"relative"}}>
                  <div className={`ui labeled input ${ImModuleStyle['ui']} ${ImModuleStyle['labeled']} ${ImModuleStyle['input']}  ${calculatorPopup?.ropd ? "show" : ""}`}>
                    <div className={`ui label ${ImModuleStyle['ui']} ${ImModuleStyle['label']}`} aria-label='d is estimated Daily Demand. If you notice demand being higher or lower, that may affect when you want to reorder.' >
                      <label htmlFor='ropd' style={{ 'font-size': '14px' }} aria-hidden="true" data-tooltip="d is estimated Daily Demand. If you notice demand being higher or lower, that may affect when you want to reorder." data-position="bottom center">d</label>
                    </div>
                    <input id='ropd' name="ropd" autoComplete="off" type="text" value={calculator.ropd} maxlength="3" onChange={updateInput} />
                  </div>
                  {
                    calculatorPopup?.ropd && <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['multi-calc-custom1']}`} role='dialog' aria-modal="true" aria-label="Daily demand popup" tabIndex={-1} style={{top: calculatorRopdPopupTop+"px"}}>
                      <p>
                        Use your daily demand here.
                      </p>
                      <div className={`mt10 dflex`}>
                        <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                        <Button btnName="Next" btnParentClassName={`ml10`} btnId="btnNext1" btnWidth="80" clickEventHandler={() => {
                          setCalculatorPopup((prevCalculator) => ({
                            ...prevCalculator,
                            ["ropd"]: false,
                            ["ropl"]: true
                          }));
                        }} />
                      </div>
                    </div>
                  }
                  </div>
                  
                  
                  <span className={`${ImModuleStyle['cross']}`} aria-label='multiplied by'><span aria-hidden={true}>x</span></span>
                  <div className={`ui labeled input ${ImModuleStyle['ui']} ${ImModuleStyle['labeled']} ${ImModuleStyle['input']}  ${calculatorPopup?.ropl ? "show" : ""}`}>
                    <div className={`ui label ${ImModuleStyle['ui']} ${ImModuleStyle['label']}`} aria-label='L is Lead time, or the time it takes your order to be available in inventory. L is a constant 5 days unless you pay extra for an expedited order.'>
                      <label htmlFor='ropl' aria-hidden="true" data-tooltip="L is Lead time, or the time it takes your order to be available in inventory. L is a constant 5 days unless you pay extra for an expedited order." data-position="bottom center">L</label>
                    </div>
                    <input id='ropl' name="ropl" autoComplete="off" type="text" style={{ "width": "20px" }} maxlength="1" value={calculator.ropl} onChange={updateInput} />
                  </div>
                  {
                    calculatorPopup?.ropl && <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['multi-calc-custom2']}`} role='dialog' aria-modal="true" aria-label="Lead time popup" tabIndex={-1} style={{top: calculatorRoplPopupTop+"px"}}>
                      <p>
                        L is Lead time, or the time it takes your order to be available in inventory. L is a constant 5 days unless you pay extra for an expedited order.
                      </p>
                      {
                        isFromHelp ? <div className={`mt10 dflex`}>
                          <Button btnName="Finish" btnParentClassName={`ml10`} btnId="btnNext1" btnWidth="80" clickEventHandler={() => {
                            setCalculatorPopup((prevCalculator) => ({
                              ...prevCalculator,
                              ["ropl"]: false
                            }));
                            setIsOverlay(false);
                            setIsFromHelp(false);
                          }} />
                        </div>
                          :
                          <div className={`${ImModuleStyle.mt10} ${ImModuleStyle.dflex}`} >
                            <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                            <Button btnName="Next" btnId="btnNext" btnParentClassName={`${ImModuleStyle.ml10}`} btnWidth="80" clickEventHandler={() => {
                              setCalculatorPopup((prevCalculator) => ({
                                ...prevCalculator,
                                ["ropl"]: false
                              }));
                              setIsFromHelp(false);
                              setSimPrgPopup(true);
                              // setIsOverlay(false);
                            }} />
                          </div>
                      }
                    </div>
                  }
                </div>
                <div className={`${ImModuleStyle['result']}`}>
                  <p><span className={`${ImModuleStyle['equalSign']}`}>=</span><span id='ropResult'>
                    {
                      String(Math.round((calculator.ropd !== "" && calculator.ropl !== "") && calculator.ropd * calculator.ropl))
                    }
                  </span></p>
                </div>
                </div>
                {
                calculatorPopup?.rop && <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['multi-calc-custom']}`} role='dialog' aria-modal="true" aria-label="R O P popup" tabIndex={-1} style={{top: calculatorRopPopupTop+"px"}}>
                  <p>
                    ROP is your daily demand (d) multiplied by your Lead time (L).
                  </p>
                  <div className={`mt10 dflex`}>
                    <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                    <Button btnName="Next" btnParentClassName={`ml10`} btnId="btnNext1" btnWidth="80" clickEventHandler={() => {
                      setCalculatorPopup((prevCalculator) => ({
                        ...prevCalculator,
                        ["rop"]: false,
                        ["ropd"]: true
                      }));
                    }} />
                  </div>
                </div>
              }
              </div>
              
            </div>
          </div>
        </div>
      </div>

      <hr aria-hidden="true" role="presentation" />
      <div className={`${ImModuleStyle['activities']}`}>
        <SimProgress actions={[playSimulation, resumeSimulation, pauseSimulation, toggleSimulation, setToggleSimulation, isShowPlaceOrder]} popupState={[simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, simObj, setSimObj, getMonth, isLoader, setIsLoader, setError, error, isRequestLoading, expandCalcPopup, setExpandCalcPopup]} />
        <div className={`${ImModuleStyle['place-order-activity']} `}>
          <OrderTable simObj={simObj} setSimObj={setSimObj} placeOrder={placeOrder} toggleSimulation={toggleSimulation} isShowPlaceOrder={isShowPlaceOrder} orderState={[quantity, setQuantity, shippingType, setShippingType, isRequestLoading]} simPopup={simPopup} />
          <OrderHistory simObj={simObj} setSimObj={setSimObj} getMonth={getMonth} />
        </div>
        {
          simPopup ? <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['place-order-popup']}`} role='dialog' aria-modal="true" aria-label="Place order popup" tabIndex={-1}>
            <p>Once you are ready, place your first order here. Keep in mind the total order costs.</p>
            <div className={`${ImModuleStyle.mt10} ${ImModuleStyle.dflex}`}>
              <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
              <Button btnName="Next" btnId="btnNext1" btnParentClassName={`${ImModuleStyle.ml10}`} btnWidth="80" clickEventHandler={() => {
                setSimPopup(false);
                setRelaunchPopup(true);
              }} />
            </div>
          </div> : ''
        }
      </div>
      {/* <div className={`${ImModuleStyle['simmsg-container']}`}>
        {
          (((toggleSimulation && simObj.status != 'COMPLETED') && !isShowPlaceOrder) || (!(toggleSimulation && simObj.status != 'COMPLETED') && isShowPlaceOrder) || (!(toggleSimulation && simObj.status != 'COMPLETED') && !isShowPlaceOrder && (simObj.status == 'COMPLETED'))) && <div className={`ui success message ${ImModuleStyle.ui} ${ImModuleStyle.success} ${ImModuleStyle.message} ${ImModuleStyle.simmsg}`}>
            <div role='alert'>
              <img src={info} />
              {
                (toggleSimulation && simObj.status != 'COMPLETED') && <p>Pause the simulation to make a new decision.</p>
              }
              {
                isShowPlaceOrder && <p className='placeorder-msg'>{`Your order is placed, please click on ${simObj?.currentstep > 0 ? 'Resume' : 'Start'} Simulation to continue.`}</p>
              }
              {
                (simObj.status == 'COMPLETED') && <p>{`Simulation is completed! Please click on "Show Summary" to view report.`}</p>
              }
            </div>
          </div>
        }
      </div> */}
      <hr className={`${ImModuleStyle['mt0']}`} aria-hidden="true" role="presentation" />
      <div className={`${ImModuleStyle['graph-wrapper']}`}>
        <div className={`${ImModuleStyle['_graph']}`}>
          <div className={`${ImModuleStyle['options']}`}>
          <div className={`${ImModuleStyle['Revenue-cost-legends']} ${ImModuleStyle['Revenue-cost-landing']}`}>
            <div className={`${ImModuleStyle['container-div']}`} aria-hidden="true">
              <div className={`${ImModuleStyle['circle-line']}`}></div>
              <div className={`${ImModuleStyle['horizontal-line-circle']}`}></div>  
            </div>
            <div>Revenue</div>
            <div className ={`${ImModuleStyle['container-div']}`} aria-hidden="true">
            <div className ={`${ImModuleStyle['horizontal-line-rhombus']}`}></div>
            <div className ={`${ImModuleStyle['rhombus']}`}></div>
            <div className ={`${ImModuleStyle['circle-rhombus']}`}></div>
            </div>
            <div>Costs</div>
</div>
            <div className={ImModuleStyle['action-buttons']}>
              <div className="tabs">
                <div role="tablist" aria-label="Graphs Tabs" className="Graphs">
                  <button
                    className={`month ui button ${ImModuleStyle['ui']} ${ImModuleStyle['button']} ${periodicalType === "monthly" ? ImModuleStyle['active'] : ''}`}
                    type="button"
                    role="tab"
                    onClick={funMonthlyHandler}
                    style={{
                      color: periodicalType === "monthly" ? "#B90000" : "black",
                      transition: "border-bottom 0.2s",
                      borderBottom: periodicalType === "monthly" ? "2px solid #B90000" : "",
                      borderRadius: 0
                    }}
                    aria-selected={periodicalType === 'monthly'}
                    //tabindex={periodicalType === 'monthly' ? "0" : "-1"}
                    aria-controls="tabpanel-1"
                    id="tab-1"
                  >
                    THIS MONTH
                  </button>
                  <button
                    className={`quarter ui button ${ImModuleStyle['ui']} ${ImModuleStyle['button']} ${periodicalType === "quarterly" ? ImModuleStyle['active'] : ''}`}
                    type="button"
                    role="tab"
                    onClick={funQuarterlyHandler}
                    style={{
                      color: periodicalType === "quarterly" ? "#B90000" : "black",
                      transition: "border-bottom 0.2s",
                      borderBottom: periodicalType === "quarterly" ? "2px solid #B90000" : "",
                      borderRadius: 0
                    }}
                    aria-selected={periodicalType === 'quarterly'}
                    //tabindex={periodicalType === 'quarterly' ? "0" : "-1"}
                    aria-controls="tabpanel-2"
                    tabIndex="-1"
                    id="tab-2"
                  >
                    THIS QUARTER
                  </button>
                  <button
                    className={`year ui button ${ImModuleStyle['ui']} ${ImModuleStyle['button']} ${periodicalType === "yearly" ? ImModuleStyle['active'] : ''}`}
                    type="button"
                    role="tab"
                    onClick={funYearlyHandler}
                    style={{
                      color: periodicalType === "yearly" ? "#B90000" : "black",
                      transition: "border-bottom 0.2s",
                      borderBottom: periodicalType === "yearly" ? "2px solid #B90000" : "",
                      borderRadius: 0
                    }}
                    aria-selected={periodicalType === 'yearly'}
                    //tabindex={periodicalType === 'yearly' ? "0" : "-1"}
                    tabIndex="-1"
                    aria-controls="tabpanel-3"
                    id="tab-3"
                  >
                    YEAR-TO-DATE
                  </button>
                  <a onClick={() => openNewWindow()} aria-hidden="true" tabIndex="-1" className="sr-only">Open a table version of graphdata</a>                </div>
              </div>
            </div>
          </div>
          <RevenueGraph type={periodicalType} isDecisionPopup={isDecisionPopup} showDecisionPopupHandler={showDecisionPopup} hideDecisionPopupHandler={hideDecisionPopup} simObj={simObj} setSimObj={setSimObj} point={point} setPoint={setPoint} />
          <div className={`${ImModuleStyle['inventorygraph-legend']}`}><span className={`${ImModuleStyle['inventory-legend']} ${ImModuleStyle['inventorypattern']}`} aria-hidden="true">&#8226;</span><div>Inventory</div></div>
          <InventoryGraph type={periodicalType} isDecisionPopup={isDecisionPopup} showDecisionPopupHandler={showDecisionPopup} hideDecisionPopupHandler={hideDecisionPopup} simObj={simObj} setSimObj={setSimObj} />
        </div>
      </div>
      {/* <div role={"dialog"} className={`ui tiny modal user-input ${ImModuleStyle["ui"]} ${ImModuleStyle["tiny"]} ${ImModuleStyle["modal"]} ${ImModuleStyle["user-input"]}`}>
        <table className={`ui unstackable table ${ImModuleStyle["ui"]} ${ImModuleStyle["unstackable"]} ${ImModuleStyle["table"]}`} role='presentation'>
            <tbody>
              <tr>
                <td className={`${ImModuleStyle["label"]}`} aria-hidden="true"> <label htmlFor="userData" id="userDataLabel">Name Your Store</label></td>
                <td>
                  <div className={`ui input left aligned`}>
                    <input type="text" placeholder="DigiLife" id="userData" className="user-data-input" autoComplete='off' aria-labelledby="userDataLabel"/>
                  </div>
                </td>
              </tr>
              <tr>
                <td></td>
                <td className={`actions left aligned ${ImModuleStyle["actions"]}`}>
                  <Button btnName={"Skip"} btnClass={`btn_cancel ${ImModuleStyle["btn_cancel"]}`}/>
                  <Button btnName={"Save"} btnClass={`btn_approve ${ImModuleStyle["btn_approve"]}`}/>
                </td>
              </tr>
              {
                (userDataInfo && userDataInfo?.valid==0) && 
                <tr style={inValidInputStyle}>
                  <td></td>
                  <td>{userDataInfo?.message}</td>
                </tr>
              }
            </tbody>
        </table>
      </div> */}
      {isModalVisible && (
        <>
          <div role={"dialog"} className={`custom-modal ${ImModuleStyle["custom-modal"]}`} aria-labelledby="userDataLabel">
            <table className={`custom-table ${ImModuleStyle["custom-table"]}`} role='presentation'>
                <tbody>
                  <tr>
                    <td className={`${ImModuleStyle["label"]}`} aria-hidden="true"> 
                      <label htmlFor="userData" id="userDataLabel">Name Your Store</label>
                    </td>
                    <td>
                      <div className={`custom-input ${ImModuleStyle["custom-input"]}`}>
                        <input type="text" placeholder="DigiLife" id="userData" className="user-data-input" autoComplete='off' aria-labelledby="userDataLabel" value={inputValue} onChange={(e) => setInputValue(e.target.value)} />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td className={`actions left aligned ${ImModuleStyle["actions"]}`}>
                      <Button btnName={"Skip"} btnClass={`btn_cancel ${ImModuleStyle["btn_cancel"]}`}/>
                      <Button btnName={"Save"} btnClass={`btn_approve ${ImModuleStyle["btn_approve"]}`}/>
                    </td>
                  </tr>
                  {
                    (userDataInfo && userDataInfo?.valid==0) && 
                    <tr style={inValidInputStyle}>
                      <td></td>
                      <td>{userDataInfo?.message}</td>
                    </tr>
                  }
                </tbody>
            </table>
          </div>
        </>
      )}
    </motion.div>

  )
}

export default Simulation